module.exports = __webpack_public_path__ + "static/media/about-bg.66cb332b.jpg";